﻿import React, { useState } from 'react';

import { GMetrixDialog } from 'components/GMetrixDialog/GMetrixDialog';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { GroupDetailsContext } from 'pages/groups/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { StudentGroupApi } from 'apis/StudentGroupApi';
import { useNotification } from 'app/notifications';
import { useContext } from 'components/Tabs';

import 'components/GroupIndentifierDialog/group-identifier-dialog.scss';

interface GroupIdentifierDialogProps {
	code: string | undefined;
	onCancel: () => void;
	setShowEditCode: React.Dispatch<React.SetStateAction<boolean>>;
	show: boolean;
}

export function GroupIdentifierDialog({
    code,
    onCancel,
    setShowEditCode,
    show
}: GroupIdentifierDialogProps) {

    const { formatMessage } = useIntl();
    const [codeIdentifier, setCodeIdentifier] = useState(code ?? '');
    const [codeIdentifierDefault, setCodeIdentifierDefault] = useState(code ?? '');
    const { pageContext, update } = useContext(GroupDetailsContext);
    const { createToast } = useNotification();

    const editCode = () => {

        if (pageContext && pageContext.Data.groupDetails) {

            let description = pageContext.Data.groupDetails?.Description;
            let maxStudents = pageContext.Data.groupDetails?.MaxStudents;
            if (description === undefined) {

                description = '';

            }
            if (maxStudents === undefined) {

                maxStudents = 0;

            }
            if (codeIdentifier) {

                StudentGroupApi.EditStudentGroupIdentifier(pageContext.Id, codeIdentifier.trim())
                    .then(group => {

                        createToast(formatMessage({ id: 'code_was_edited_successfully.885fed7e', defaultMessage: 'Code was edited successfully' }), 'success');

                        StudentGroupApi.Get(pageContext.Id)
                            .then(groupInfo => {

                                update({
                                    groupDetails: { ...groupInfo, Control: groupInfo.Control },
                                    groupDetailsOriginal: { ...groupInfo, Control: groupInfo.Control }
                                });

                            })
                            .catch(error => console.error(error));

                    })
                    .catch(error => console.error(error));

            }

        }
        setShowEditCode(false);

    };

    return (
        <>
            <GMetrixDialog
                showActionButton
                showModalLabel
                onCancel={() => {

                    setCodeIdentifier(code ?? '');
                    onCancel && onCancel();

                }}
                actionButtonClick={editCode}
                actionButtonDisabled={(codeIdentifier && codeIdentifier?.length > 20) || codeIdentifierDefault.split('-')[0] === codeIdentifier.split('-')[0]}
                actionButtonText={formatMessage({ id: 'save.d44082ae', defaultMessage: 'Save' })}
                dialogLabel={formatMessage({ id: 'change_identifier.36bc5099', defaultMessage: 'Change Identifier' })}
                show={show}
                size={'lg'}
            >
                <h6>
                    <FormattedMessage defaultMessage="You may edit the Identifier on this code below." id="you_may_edit_the_identifier_on_this_code.2bc4900f" />
                </h6>
                <GMetrixInput
                    autoFocus
                    onChange={e => {

                        setCodeIdentifier(e.target.value);

                    }}
                    label={formatMessage({ id: 'identifier_20_characters_or_less.13482ae8', defaultMessage: 'Identifier (20 characters or less)' })}
                    maxLength={20}
                    value={codeIdentifier?.split('-')[0]}
                />
            </GMetrixDialog>
        </>
    );

}
